import { render, staticRenderFns } from "./CardMeasurerVertical.vue?vue&type=template&id=95a3816e&scoped=true&"
import script from "./CardMeasurerVertical.vue?vue&type=script&lang=js&"
export * from "./CardMeasurerVertical.vue?vue&type=script&lang=js&"
import style0 from "./CardMeasurerVertical.vue?vue&type=style&index=0&id=95a3816e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95a3816e",
  null
  
)

export default component.exports